import ExpansionPanelHeader from "./ExpansionPanelHeader";

export default ExpansionPanelHeader;
